import { useState } from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import { postJson } from "../auth/api";
import { Button, Drawer } from "../components/ui";

const links = [
  ["/member", "Tổng quan"],
  ["/member/dogs", "Hồ sơ chó của tôi"],
  ["/member/ownership/dogs", "Chó tôi có quyền quản lý"],
  ["/member/ownership", "Quyền & lời mời"],
  ["/member/taxonomy", "Tra cứu giống & danh mục"],
  ["/member/profile", "Hồ sơ cá nhân"],
  ["/member/security", "Bảo mật và phiên"],
] as const;

export function MemberShell() {
  const [open, setOpen] = useState(false);
  const { principal, clear } = useAuth();
  const navigate = useNavigate();
  const canModerateDogs = principal?.permissions.includes("dogs:read:global") ?? false;
  const canModerateOwnership = principal?.permissions.includes("dogs:ownership_moderate:global") ?? false;
  const canModeratePedigree = principal?.permissions.includes("pedigree:moderate:global") ?? false;

  async function logout() {
    await postJson("/api/v1/auth/logout", {}).catch(() => undefined);
    clear();
    navigate("/login", { replace: true });
  }

  const nav = (
    <nav className="side-nav" aria-label="Điều hướng thành viên">
      {links.map(([to, label]) => (
        <NavLink key={to} to={to} end={to === "/member"} onClick={() => setOpen(false)}>
          {label}
        </NavLink>
      ))}
      {canModerateDogs ? (
        <NavLink to="/member/moderation/dogs" onClick={() => setOpen(false)}>
          Kiểm duyệt hồ sơ chó
        </NavLink>
      ) : null}
      {canModerateOwnership ? (
        <NavLink to="/member/moderation/ownership" onClick={() => setOpen(false)}>
          Kiểm duyệt ownership
        </NavLink>
      ) : null}
      {canModeratePedigree ? (
        <NavLink to="/member/moderation/pedigree" onClick={() => setOpen(false)}>
          Kiểm duyệt phả hệ
        </NavLink>
      ) : null}
      <button type="button" className="side-nav__action" onClick={() => void logout()}>
        Đăng xuất
      </button>
    </nav>
  );

  return (
    <div className="workspace-shell">
      <aside className="workspace-sidebar">
        <NavLink className="brand brand-inverse" to="/">
          <span className="brand-mark">WD</span>
          <span>
            <strong>WorkingDog VN</strong>
            <small>{principal?.displayName ?? "Thành viên"}</small>
          </span>
        </NavLink>
        {nav}
      </aside>
      <section className="workspace-main">
        <header className="workspace-topbar">
          <Button
            variant="secondary"
            size="sm"
            onClick={() => setOpen(true)}
            className="mobile-only"
          >
            Menu
          </Button>
          <div>
            <p className="eyebrow">Khu vực thành viên</p>
            <h1>{principal?.displayName ?? "Tài khoản"}</h1>
          </div>
          <NavLink className="text-link" to="/">
            Về trang công khai
          </NavLink>
        </header>
        <main className="workspace-content">
          <Outlet />
        </main>
      </section>
      <Drawer open={open} title="Điều hướng thành viên" onClose={() => setOpen(false)}>
        {nav}
      </Drawer>
    </div>
  );
}
